app.controller('RefundCtrl', function ($scope, $rootScope, $http, $timeout, $uibModal, loginService) {
    this.user = loginService.currentUser;
    
    this.cancelAndRefundModal = (serviceId, userName) => {
        $uibModal
            .open({
                component: 'cancel-and-refund',
                windowClass: 'cancel-and-refund-modal',
                animation: false,
                size: 'md',
                resolve: {
                    serviceId: () => {
                        return serviceId;
                    },
                    userName: () => {
                        return userName;
                    },
                }
            })
            .result
            .then(onClose, onClose)
            .catch(onError('cancel-and-refund'));
    };

    const onOpen = (serviceId, userName) => {
        this.cancelAndRefundModal(serviceId, userName);
    };

    const onClose = () => {
        console.log('cancel action performed');
    };

    const onCancel = () => {
        console.log('cancel action performed');
    };

    const onError = (name) => {
        return (err) => {
            console.log('',err);
        };
    };
});